// extracted by mini-css-extract-plugin
export default {"container":"Main_container__M2M-y","content":"Main_content__nAnpL","hero":"Main_hero__r7Fuw"};